import aboutUsFallback from '@/assets/images/about-us.png?w=1000'
import aboutUsAvif from '@/assets/images/about-us.png?w=1000&format=avif&as=srcset'
import aboutUsWebp from '@/assets/images/about-us.png?w=1000&format=webp&as=srcset'
import ChristmasCalendarDefaultFallback from '@/assets/images/christmas_calendar_default.jpg?w=1250'
import ChristmasCalendarDefaultAvif from '@/assets/images/christmas_calendar_default.jpg?w=1250&format=avif&as=srcset'
import ChristmasCalendarDefaultWebp from '@/assets/images/christmas_calendar_default.jpg?w=1250&format=webp&as=srcset'
import hpHeroFallback from '@/assets/images/hp-cover-valentine.jpg?w=1920'
import hpHeroAvif from '@/assets/images/hp-cover-valentine.jpg?w=1920&format=avif&as=srcset'
import hpHeroWebp from '@/assets/images/hp-cover-valentine.jpg?w=1920&format=webp&as=srcset'
import hpHeroMobileFallback from '@/assets/images/hp-cover-mobile-valentine.jpg?w=1920'
import hpHeroMobileAvif from '@/assets/images/hp-cover-mobile-valentine.jpg?w=1920&format=avif&as=srcset'
import hpHeroMobileWebp from '@/assets/images/hp-cover-mobile-valentine.jpg?w=1920&format=webp&as=srcset'
import mixitPlusIntroFallback from '@/assets/images/mixit_plus/intro.jpg?w=1920'
import mixitPlusIntroAvif from '@/assets/images/mixit_plus/intro.jpg?w=1920&format=avif&as=srcset'
import mixitPlusIntroWebp from '@/assets/images/mixit_plus/intro.jpg?w=1920&format=webp&as=srcset'
import clubIntroFallback from '@/assets/images/club/intro.jpg?w=1920'
import clubIntroAvif from '@/assets/images/club/intro.jpg?w=1920&format=avif&as=srcset'
import clubIntroWebp from '@/assets/images/club/intro.jpg?w=1920&format=webp&as=srcset'
import clubJulyAvif from '@/assets/images/club/package-july.png?w=500&format=avif&as=srcset'
import clubJulyWebp from '@/assets/images/club/package-july.png?w=500&format=webp&as=srcset'
import clubJulyFallback from '@/assets/images/club/package-july.png?w=700'
import clubNovemberAvif from '@/assets/images/club/package-november.png?w=500&format=avif&as=srcset'
import clubNovemberWebp from '@/assets/images/club/package-november.png?w=500&format=webp&as=srcset'
import clubNovemberFallback from '@/assets/images/club/package-november.png?w=700'
import clubOctoberAvif from '@/assets/images/club/package-october.png?w=500&format=avif&as=srcset'
import clubOctoberWebp from '@/assets/images/club/package-october.png?w=500&format=webp&as=srcset'
import clubOctoberFallback from '@/assets/images/club/package-october.png?w=700'
import clubLogoAvif from '@/assets/images/club/logo.png?w=500&format=avif&as=srcset'
import clubLogoWebp from '@/assets/images/club/logo.png?w=500&format=webp&as=srcset'
import clubLogoFallback from '@/assets/images/club/logo.png?w=700'
import companyGiftsIntroAvif from '@/assets/images/company-gifts/intro.jpg?w=1920&format=avif&as=srcset'
import companyGiftsIntroWebp from '@/assets/images/company-gifts/intro.jpg?w=1920&format=webp&as=srcset'
import companyGiftsIntroFallback from '@/assets/images/company-gifts/intro.jpg?w=1920'
import companyGiftsHeroFallback from '@/assets/images/company-gifts-hero.png?w=1944'
import companyGiftsHeroAvif from '@/assets/images/company-gifts-hero.png?w=1944&format=avif&as=srcset'
import companyGiftsHeroWebp from '@/assets/images/company-gifts-hero.png?w=1944&format=webp&as=srcset'
import companyGiftsClientsFallback from '@/assets/images/company-gifts-clients.png?w=19557'
import companyGiftsClientsAvif from '@/assets/images/company-gifts-clients.png?w=19557&format=avif&as=srcset'
import companyGiftsClientsWebp from '@/assets/images/company-gifts-clients.png?w=19557&format=webp&as=srcset'
import giftPackageAvif from '@/assets/images/company-gifts/gift_package.jpg?w=500&format=avif&as=srcset'
import giftPackageWebp from '@/assets/images/company-gifts/gift_package.jpg?w=500&format=webp&as=srcset'
import giftPackageFallback from '@/assets/images/company-gifts/gift_package.jpg?w=700'
import mixitsWithCorporateDepositAvif from '@/assets/images/company-gifts/mixits_with_corporate_deposit.jpg?w=500&format=avif&as=srcset'
import mixitsWithCorporateDepositWebp from '@/assets/images/company-gifts/mixits_with_corporate_deposit.jpg?w=500&format=webp&as=srcset'
import mixitsWithCorporateDepositFallback from '@/assets/images/company-gifts/mixits_with_corporate_deposit.jpg?w=700'
import otherCustomAreasAvif from '@/assets/images/company-gifts/other_custom_areas.jpg?w=500&format=avif&as=srcset'
import otherCustomAreasWebp from '@/assets/images/company-gifts/other_custom_areas.jpg?w=500&format=webp&as=srcset'
import otherCustomAreasFallback from '@/assets/images/company-gifts/other_custom_areas.jpg?w=700'
import ownDesignAvif from '@/assets/images/company-gifts/own_design.jpg?w=500&format=avif&as=srcset'
import ownDesignWebp from '@/assets/images/company-gifts/own_design.jpg?w=500&format=webp&as=srcset'
import ownDesignFallback from '@/assets/images/company-gifts/own_design.jpg?w=700'
import threeSizesOfTubesAvif from '@/assets/images/company-gifts/three_sizes_of_tubes.jpg?w=500&format=avif&as=srcset'
import threeSizesOfTubesWebp from '@/assets/images/company-gifts/three_sizes_of_tubes.jpg?w=500&format=webp&as=srcset'
import threeSizesOfTubesFallback from '@/assets/images/company-gifts/three_sizes_of_tubes.jpg?w=700'
import giftPackagePreviewAvif from '@/assets/images/company-gifts/gift_package.png?w=500&format=avif&as=srcset'
import giftPackagePreviewWebp from '@/assets/images/company-gifts/gift_package.png?w=500&format=webp&as=srcset'
import giftPackagePreviewFallback from '@/assets/images/company-gifts/gift_package.png?w=700'
import mixitsWithCorporateDepositPreviewAvif from '@/assets/images/company-gifts/mixits_with_corporate_deposit.png?w=500&format=avif&as=srcset'
import mixitsWithCorporateDepositPreviewWebp from '@/assets/images/company-gifts/mixits_with_corporate_deposit.png?w=500&format=webp&as=srcset'
import mixitsWithCorporateDepositPreviewFallback from '@/assets/images/company-gifts/mixits_with_corporate_deposit.png?w=700'
import otherCustomAreasPreviewAvif from '@/assets/images/company-gifts/other_custom_areas.png?w=500&format=avif&as=srcset'
import otherCustomAreasPreviewWebp from '@/assets/images/company-gifts/other_custom_areas.png?w=500&format=webp&as=srcset'
import otherCustomAreasPreviewFallback from '@/assets/images/company-gifts/other_custom_areas.png?w=700'
import ownDesignPreviewAvif from '@/assets/images/company-gifts/own_design.png?w=500&format=avif&as=srcset'
import ownDesignPreviewWebp from '@/assets/images/company-gifts/own_design.png?w=500&format=webp&as=srcset'
import ownDesignPreviewFallback from '@/assets/images/company-gifts/own_design.png?w=700'
import threeSizesOfTubesPreviewAvif from '@/assets/images/company-gifts/three_sizes_of_tubes.png?w=500&format=avif&as=srcset'
import threeSizesOfTubesPreviewWebp from '@/assets/images/company-gifts/three_sizes_of_tubes.png?w=500&format=webp&as=srcset'
import threeSizesOfTubesPreviewFallback from '@/assets/images/company-gifts/three_sizes_of_tubes.png?w=700'
import contactAvif from '@/assets/images/contact.jpg?w=1300&format=avif&as=srcset'
import contactWebp from '@/assets/images/contact.jpg?w=1300&format=webp&as=srcset'
import contactFallback from '@/assets/images/contact.jpg?w=1300'
import defaultImgAvif from '@/assets/images/default-image.png?w=500&format=avif&as=srcset'
import defaultImgWebp from '@/assets/images/default-image.png?w=500&format=webp&as=srcset'
import defaultImgFallback from '@/assets/images/default-image.png?w=700'
import defaultReviewAvif from '@/assets/images/default-review-image.png?w=500&format=avif&as=srcset'
import defaultReviewWebp from '@/assets/images/default-review-image.png?w=500&format=webp&as=srcset'
import defaultReviewFallback from '@/assets/images/default-review-image.png?w=700'
import adamOndraAvif from '@/assets/images/landing_pages/adam-ondra/adam-ondra.jpg?w=500&format=avif&as=srcset'
import adamOndraWebp from '@/assets/images/landing_pages/adam-ondra/adam-ondra.jpg?w=500&format=webp&as=srcset'
import adamOndraFallback from '@/assets/images/landing_pages/adam-ondra/adam-ondra.jpg?w=700'
import adamOndraBackgroundFallback from '@/assets/images/landing_pages/adam-ondra/adam-ondra-cs-header-desktop.jpg?w=700'
import adamOndraBackgroundAvif from '@/assets/images/landing_pages/adam-ondra/adam-ondra-cs-header-desktop.jpg?w=1920&format=avif&as=srcset'
import adamOndraBackgroundWebp from '@/assets/images/landing_pages/adam-ondra/adam-ondra-cs-header-desktop.jpg?w=1920&format=webp&as=srcset'
import adamOndraMobileBackgroundAvif from '@/assets/images/landing_pages/adam-ondra/adam-ondra-cs-header-phone.jpg?w=500&format=avif&as=srcset'
import adamOndraMobileBackgroundWebp from '@/assets/images/landing_pages/adam-ondra/adam-ondra-cs-header-phone.jpg?w=500&format=webp&as=srcset'
import adamOndraMobileBackgroundFallback from '@/assets/images/landing_pages/adam-ondra/adam-ondra-cs-header-phone.jpg?w=700'
import adamOndraNews1Avif from '@/assets/images/landing_pages/adam-ondra/news/news-1.png?w=300&format=avif&as=srcset'
import adamOndraNews1Webp from '@/assets/images/landing_pages/adam-ondra/news/news-1.png?w=300&format=webp&as=srcset'
import adamOndraNews1Fallback from '@/assets/images/landing_pages/adam-ondra/news/news-1.png?w=500'
import adamOndraNews2Avif from '@/assets/images/landing_pages/adam-ondra/news/news-2.jpeg?w=300&format=avif&as=srcset'
import adamOndraNews2Webp from '@/assets/images/landing_pages/adam-ondra/news/news-2.jpeg?w=300&format=webp&as=srcset'
import adamOndraNews2Fallback from '@/assets/images/landing_pages/adam-ondra/news/news-2.jpeg?w=500'
import adamOndraNews3Avif from '@/assets/images/landing_pages/adam-ondra/news/news-3.jpeg?w=300&format=avif&as=srcset'
import adamOndraNews3Webp from '@/assets/images/landing_pages/adam-ondra/news/news-3.jpeg?w=300&format=webp&as=srcset'
import adamOndraNews3Fallback from '@/assets/images/landing_pages/adam-ondra/news/news-3.jpeg?w=500'
import cemeteryHeaderBackgroundFallback from '@/assets/images/landing_pages/cemetery/cemetery-header-desktop.jpg?w=1920'
import cemeteryHeaderBackgroundAvif from '@/assets/images/landing_pages/cemetery/cemetery-header-desktop.jpg?w=1920&format=avif&as=srcset'
import cemeteryHeaderBackgroundWebp from '@/assets/images/landing_pages/cemetery/cemetery-header-desktop.jpg?w=1920&format=webp&as=srcset'
import cemeteryHeaderMobileBackgroundFallback from '@/assets/images/landing_pages/cemetery/cemetery-header-phone.jpg?w=800'
import cemeteryHeaderMobileBackgroundAvif from '@/assets/images/landing_pages/cemetery/cemetery-header-phone.jpg?w=800&format=avif&as=srcset'
import cemeteryHeaderMobileBackgroundWebp from '@/assets/images/landing_pages/cemetery/cemetery-header-phone.jpg?w=800&format=webp&as=srcset'
import cemeteryBackgroundFallback from '@/assets/images/landing_pages/cemetery/cemetery-main-bg.jpg?w=1920'
import cemeteryBackgroundAvif from '@/assets/images/landing_pages/cemetery/cemetery-main-bg.jpg?w=1920&format=avif&as=srcset'
import cemeteryBackgroundWebp from '@/assets/images/landing_pages/cemetery/cemetery-main-bg.jpg?w=1920&format=webp&as=srcset'
import cemeteryMobileBackgroundFallback from '@/assets/images/landing_pages/cemetery/cemetery-main-bg-phone.jpg?w=800'
import cemeteryMobileBackgroundAvif from '@/assets/images/landing_pages/cemetery/cemetery-main-bg-phone.jpg?w=800&format=avif&as=srcset'
import cemeteryMobileBackgroundWebp from '@/assets/images/landing_pages/cemetery/cemetery-main-bg-phone.jpg?w=800&format=webp&as=srcset'
import jiriProchazkaAvif from '@/assets/images/landing_pages/jiri_prochazka/jiri-prochazka.jpg?w=500&format=avif&as=srcset'
import jiriProchazkaWebp from '@/assets/images/landing_pages/jiri_prochazka/jiri-prochazka.jpg?w=500&format=webp&as=srcset'
import jiriProchazkaFallback from '@/assets/images/landing_pages/jiri_prochazka/jiri-prochazka.jpg?w=700'
import jiriProchazkaBackgroundFallback from '@/assets/images/landing_pages/jiri_prochazka/jiri-prochazka-header-desktop.jpg?w=700'
import jiriProchazkaBackgroundAvif from '@/assets/images/landing_pages/jiri_prochazka/jiri-prochazka-header-desktop.jpg?w=1920&format=avif&as=srcset'
import jiriProchazkaBackgroundWebp from '@/assets/images/landing_pages/jiri_prochazka/jiri-prochazka-header-desktop.jpg?w=1920&format=webp&as=srcset'
import jiriProchazkaMobileBackgroundAvif from '@/assets/images/landing_pages/jiri_prochazka/jiri-prochazka-header-phone.jpg?w=500&format=avif&as=srcset'
import jiriProchazkaMobileBackgroundWebp from '@/assets/images/landing_pages/jiri_prochazka/jiri-prochazka-header-phone.jpg?w=500&format=webp&as=srcset'
import jiriProchazkaMobileBackgroundFallback from '@/assets/images/landing_pages/jiri_prochazka/jiri-prochazka-header-phone.jpg?w=700'
import jiriProchazkaNews1Avif from '@/assets/images/landing_pages/jiri_prochazka/news/news-1.jpg?w=300&format=avif&as=srcset'
import jiriProchazkaNews1Webp from '@/assets/images/landing_pages/jiri_prochazka/news/news-1.jpg?w=300&format=webp&as=srcset'
import jiriProchazkaNews1Fallback from '@/assets/images/landing_pages/jiri_prochazka/news/news-1.jpg?w=500'
import jiriProchazkaNews2Avif from '@/assets/images/landing_pages/jiri_prochazka/news/news-2.jpg?w=300&format=avif&as=srcset'
import jiriProchazkaNews2Webp from '@/assets/images/landing_pages/jiri_prochazka/news/news-2.jpg?w=300&format=webp&as=srcset'
import jiriProchazkaNews2Fallback from '@/assets/images/landing_pages/jiri_prochazka/news/news-2.jpg?w=500'
import jiriProchazkaNews3Avif from '@/assets/images/landing_pages/jiri_prochazka/news/news-3.jpg?w=300&format=avif&as=srcset'
import jiriProchazkaNews3Webp from '@/assets/images/landing_pages/jiri_prochazka/news/news-3.jpg?w=300&format=webp&as=srcset'
import jiriProchazkaNews3Fallback from '@/assets/images/landing_pages/jiri_prochazka/news/news-3.jpg?w=500'
import retroBackgroundFallback from '@/assets/images/landing_pages/retro/retro-header-desktop.jpeg?w=1920'
import retroBackgroundAvif from '@/assets/images/landing_pages/retro/retro-header-desktop.jpeg?w=1920&format=avif&as=srcset'
import retroBackgroundWebp from '@/assets/images/landing_pages/retro/retro-header-desktop.jpeg?w=1920&format=webp&as=srcset'
import retroMobileBackgroundFallback from '@/assets/images/landing_pages/retro/retro-header-phone.jpeg?w=800'
import retroMobileBackgroundAvif from '@/assets/images/landing_pages/retro/retro-header-phone.jpeg?w=800&format=avif&as=srcset'
import retroMobileBackgroundWebp from '@/assets/images/landing_pages/retro/retro-header-phone.jpeg?w=800&format=webp&as=srcset'
import ecoBoxCreatedFallback from '@/assets/images/modals/eko_box.png?w=500'
import ecoBoxCreatedAvif from '@/assets/images/modals/eko_box.png?w=500&format=avif&as=srcset'
import ecoBoxCreatedWebp from '@/assets/images/modals/eko_box.png?w=500&format=webp&as=srcset'
import landingPageBannerFallback from '@/assets/images/ondra-prochazka-banner.jpg?w=1250'
import landingPageBannerAvif from '@/assets/images/ondra-prochazka-banner.jpg?w=1250&format=avif&as=srcset'
import landingPageBannerWebp from '@/assets/images/ondra-prochazka-banner.jpg?w=1250&format=webp&as=srcset'
import { creditStepsImages } from '@/assets/images/staticCreditPageImages'
import { paymentsImages } from '@/assets/images/staticPaymentImages'
import { transportImages } from '@/assets/images/staticTransportImages'
import { companyGiftsImages } from '@/assets/images/staticCompanyGifts'
import birthdayBannerImg1Avif from '@/assets/images/birthday-banner-img-1.png?w=208&format=avif&as=srcset'
import birthdayBannerImg1Webp from '@/assets/images/birthday-banner-img-1.png?w=208&format=webp&as=srcset'
import birthdayBannerImg1Fallback from '@/assets/images/birthday-banner-img-1.png?w=208'
import birthdayBannerImg2Avif from '@/assets/images/birthday-banner-img-2.png?w=402&format=avif&as=srcset'
import birthdayBannerImg2Webp from '@/assets/images/birthday-banner-img-2.png?w=402&format=webp&as=srcset'
import birthdayBannerImg2Fallback from '@/assets/images/birthday-banner-img-2.png?w=402'
import jobOffersAvif from '@/assets/images/job-offer.jpg?w=1200&format=avif&as=srcset'
import jobOffersWebp from '@/assets/images/job-offer.jpg?w=1200&format=webp&as=srcset'
import jobOffersFallback from '@/assets/images/job-offer.jpg?w=1200'
import tubeFallback from '@/assets/images/customer/tube.png?w=500'
import tubeAvif from '@/assets/images/customer/tube.png?w=500&format=avif&as=srcset'
import tubeWebp from '@/assets/images/customer/tube.png?w=500&format=webp&as=srcset'
import transportFallback from '@/assets/images/customer/transport.png?w=500'
import transportAvif from '@/assets/images/customer/transport.png?w=500&format=avif&as=srcset'
import transportWebp from '@/assets/images/customer/transport.png?w=500&format=webp&as=srcset'
import paymentFallback from '@/assets/images/customer/payment.png?w=500'
import paymentAvif from '@/assets/images/customer/payment.png?w=500&format=avif&as=srcset'
import paymentWebp from '@/assets/images/customer/payment.png?w=500&format=webp&as=srcset'
import badgesFallback from '@/assets/images/customer/badges.png?w=700'
import badgesAvif from '@/assets/images/customer/badges.png?w=700&format=avif&as=srcset'
import badgesWebp from '@/assets/images/customer/badges.png?w=700&format=webp&as=srcset'
import CustomerClubBgFallback from '@/assets/images/customer/customer-club-bg.png?w=1920'
import CustomerClubBgAvif from '@/assets/images/customer/customer-club-bg.png?w=1920&format=avif&as=srcset'
import CustomerClubBgWebp from '@/assets/images/customer/customer-club-bg.png?w=1920&format=webp&as=srcset'
import CustomerCreditsBgFallback from '@/assets/images/customer/customer-credits-bg.png?w=1920'
import CustomerCreditsBgAvif from '@/assets/images/customer/customer-credits-bg.png?w=1920&format=avif&as=srcset'
import CustomerCreditsBgWebp from '@/assets/images/customer/customer-credits-bg.png?w=1920&format=webp&as=srcset'
import MixitPlusBirdFallback from '@/assets/images/customer/mixit-plus-bird.png?w=500'
import MixitPlusBirdAvif from '@/assets/images/customer/mixit-plus-bird.png?w=500&format=avif&as=srcset'
import MixitPlusBirdWebp from '@/assets/images/customer/mixit-plus-bird.png?w=500&format=webp&as=srcset'

export const imageArray = [
  {
    name: 'birthday-banner-img-2.png',
    avif: birthdayBannerImg2Avif,
    webp: birthdayBannerImg2Webp,
    fallback: birthdayBannerImg2Fallback,
  },
  {
    name: 'birthday-banner-img-1.png',
    avif: birthdayBannerImg1Avif,
    webp: birthdayBannerImg1Webp,
    fallback: birthdayBannerImg1Fallback,
  },
  {
    name: 'adam-ondra-cs-header-desktop.jpg',
    avif: adamOndraBackgroundAvif,
    webp: adamOndraBackgroundWebp,
    fallback: adamOndraBackgroundFallback,
  },
  {
    name: 'adam-ondra-cs-header-phone.jpg',
    avif: adamOndraMobileBackgroundAvif,
    webp: adamOndraMobileBackgroundWebp,
    fallback: adamOndraMobileBackgroundFallback,
  },
  {
    name: 'adam-ondra.jpg',
    avif: adamOndraAvif,
    webp: adamOndraWebp,
    fallback: adamOndraFallback,
  },
  {
    name: 'jiri-prochazka.jpg',
    avif: jiriProchazkaAvif,
    webp: jiriProchazkaWebp,
    fallback: jiriProchazkaFallback,
  },
  {
    name: 'adam-ondra-news-1.png',
    avif: adamOndraNews1Avif,
    webp: adamOndraNews1Webp,
    fallback: adamOndraNews1Fallback,
  },
  {
    name: 'adam-ondra-news-2.jpeg',
    avif: adamOndraNews2Avif,
    webp: adamOndraNews2Webp,
    fallback: adamOndraNews2Fallback,
  },
  {
    name: 'adam-ondra-news-3.jpeg',
    avif: adamOndraNews3Avif,
    webp: adamOndraNews3Webp,
    fallback: adamOndraNews3Fallback,
  },
  {
    name: 'jiri-prochazka-news-1.jpg',
    avif: jiriProchazkaNews1Avif,
    webp: jiriProchazkaNews1Webp,
    fallback: jiriProchazkaNews1Fallback,
  },
  {
    name: 'jiri-prochazka-news-2.jpg',
    avif: jiriProchazkaNews2Avif,
    webp: jiriProchazkaNews2Webp,
    fallback: jiriProchazkaNews2Fallback,
  },
  {
    name: 'jiri-prochazka-news-3.jpg',
    avif: jiriProchazkaNews3Avif,
    webp: jiriProchazkaNews3Webp,
    fallback: jiriProchazkaNews3Fallback,
  },
  {
    name: 'jiri-prochazka-header-desktop.jpg',
    avif: jiriProchazkaBackgroundAvif,
    webp: jiriProchazkaBackgroundWebp,
    fallback: jiriProchazkaBackgroundFallback,
  },
  {
    name: 'jiri-prochazka-header-phone.jpg',
    avif: jiriProchazkaMobileBackgroundAvif,
    webp: jiriProchazkaMobileBackgroundWebp,
    fallback: jiriProchazkaMobileBackgroundFallback,
  },
  {
    name: 'about-us.png',
    avif: aboutUsAvif,
    webp: aboutUsWebp,
    fallback: aboutUsFallback,
  },
  {
    name: 'retro-header-desktop.jpg',
    avif: retroBackgroundAvif,
    webp: retroBackgroundWebp,
    fallback: retroBackgroundFallback,
  },
  {
    name: 'retro-header-phone.jpg',
    avif: retroMobileBackgroundAvif,
    webp: retroMobileBackgroundWebp,
    fallback: retroMobileBackgroundFallback,
  },
  {
    name: 'cemetery-header-desktop.jpg',
    avif: cemeteryHeaderBackgroundAvif,
    webp: cemeteryHeaderBackgroundWebp,
    fallback: cemeteryHeaderBackgroundFallback,
  },
  {
    name: 'cemetery-header-phone.jpg',
    avif: cemeteryHeaderMobileBackgroundAvif,
    webp: cemeteryHeaderMobileBackgroundWebp,
    fallback: cemeteryHeaderMobileBackgroundFallback,
  },
  {
    name: 'cemetery-main-bg.jpg',
    avif: cemeteryBackgroundAvif,
    webp: cemeteryBackgroundWebp,
    fallback: cemeteryBackgroundFallback,
  },
  {
    name: 'cemetery-main-bg-phone.jpg',
    avif: cemeteryMobileBackgroundAvif,
    webp: cemeteryMobileBackgroundWebp,
    fallback: cemeteryMobileBackgroundFallback,
  },
  {
    name: 'contact.jpg',
    avif: contactAvif,
    webp: contactWebp,
    fallback: contactFallback,
  },
  {
    name: 'default-review-image.png',
    avif: defaultReviewAvif,
    webp: defaultReviewWebp,
    fallback: defaultReviewFallback,
  },
  {
    name: 'hp-cover.jpg',
    avif: hpHeroAvif,
    webp: hpHeroWebp,
    fallback: hpHeroFallback,
  },
  {
    name: 'hp-cover-mobile.jpg',
    avif: hpHeroMobileAvif,
    webp: hpHeroMobileWebp,
    fallback: hpHeroMobileFallback,
  },
  {
    name: 'club/intro.jpg',
    avif: clubIntroAvif,
    webp: clubIntroWebp,
    fallback: clubIntroFallback,
  },
  {
    name: 'club/logo.png',
    avif: clubLogoAvif,
    webp: clubLogoWebp,
    fallback: clubLogoFallback,
  },
  {
    name: 'mixit_plus/intro.jpg',
    avif: mixitPlusIntroAvif,
    webp: mixitPlusIntroWebp,
    fallback: mixitPlusIntroFallback,
  },
  {
    name: 'club/package-july.png',
    avif: clubJulyAvif,
    webp: clubJulyWebp,
    fallback: clubJulyFallback,
  },
  {
    name: 'club/package-november.png',
    avif: clubNovemberAvif,
    webp: clubNovemberWebp,
    fallback: clubNovemberFallback,
  },
  {
    name: 'club/package-october.png',
    avif: clubOctoberAvif,
    webp: clubOctoberWebp,
    fallback: clubOctoberFallback,
  },
  {
    name: 'christmas_calendar_default.jpg',
    avif: ChristmasCalendarDefaultAvif,
    webp: ChristmasCalendarDefaultWebp,
    fallback: ChristmasCalendarDefaultFallback,
  },
  {
    name: 'ondra-prochazka-banner.jpg',
    avif: landingPageBannerAvif,
    webp: landingPageBannerWebp,
    fallback: landingPageBannerFallback,
  },
  {
    name: 'modals/eko_box.png',
    avif: ecoBoxCreatedAvif,
    webp: ecoBoxCreatedWebp,
    fallback: ecoBoxCreatedFallback,
  },
  {
    name: 'customer/tube.png',
    avif: tubeAvif,
    webp: tubeWebp,
    fallback: tubeFallback,
  },
  {
    name: 'customer/badges.png',
    avif: badgesAvif,
    webp: badgesWebp,
    fallback: badgesFallback,
  },
  {
    name: 'customer/payment.png',
    avif: paymentAvif,
    webp: paymentWebp,
    fallback: paymentFallback,
  },
  {
    name: 'customer/transport.png',
    avif: transportAvif,
    webp: transportWebp,
    fallback: transportFallback,
  },
  {
    name: 'customer/customer-club-bg.png',
    avif: CustomerClubBgAvif,
    webp: CustomerClubBgWebp,
    fallback: CustomerClubBgFallback,
  },
  {
    name: 'customer/customer-credits-bg.png',
    avif: CustomerCreditsBgAvif,
    webp: CustomerCreditsBgWebp,
    fallback: CustomerCreditsBgFallback,
  },
  {
    name: 'customer/mixit-plus-bird.png',
    avif: MixitPlusBirdAvif,
    webp: MixitPlusBirdWebp,
    fallback: MixitPlusBirdFallback,
  },
  {
    name: 'company-gifts/gift_package.jpg',
    avif: giftPackageAvif,
    webp: giftPackageWebp,
    fallback: giftPackageFallback,
  },
  {
    name: 'company-gifts/mixits_with_corporate_deposit.jpg',
    avif: mixitsWithCorporateDepositAvif,
    webp: mixitsWithCorporateDepositWebp,
    fallback: mixitsWithCorporateDepositFallback,
  },
  {
    name: 'company-gifts/other_custom_areas.jpg',
    avif: otherCustomAreasAvif,
    webp: otherCustomAreasWebp,
    fallback: otherCustomAreasFallback,
  },
  {
    name: 'company-gifts/own_design.jpg',
    avif: ownDesignAvif,
    webp: ownDesignWebp,
    fallback: ownDesignFallback,
  },
  {
    name: 'company-gifts/three_sizes_of_tubes.jpg',
    avif: threeSizesOfTubesAvif,
    webp: threeSizesOfTubesWebp,
    fallback: threeSizesOfTubesFallback,
  },
  {
    name: 'company-gifts/intro.jpg',
    avif: companyGiftsIntroAvif,
    webp: companyGiftsIntroWebp,
    fallback: companyGiftsIntroFallback,
  },
  {
    name: 'company-gifts-hero.png',
    avif: companyGiftsHeroAvif,
    webp: companyGiftsHeroWebp,
    fallback: companyGiftsHeroFallback,
  },
  {
    name: 'company-gifts-clients.png',
    avif: companyGiftsClientsAvif,
    webp: companyGiftsClientsWebp,
    fallback: companyGiftsClientsFallback,
  },
  {
    name: 'company-gifts/mixits_with_corporate_deposit.png',
    avif: mixitsWithCorporateDepositPreviewAvif,
    webp: mixitsWithCorporateDepositPreviewWebp,
    fallback: mixitsWithCorporateDepositPreviewFallback,
  },
  {
    name: 'company-gifts/other_custom_areas.png',
    avif: otherCustomAreasPreviewAvif,
    webp: otherCustomAreasPreviewWebp,
    fallback: otherCustomAreasPreviewFallback,
  },
  {
    name: 'company-gifts/own_design.png',
    avif: ownDesignPreviewAvif,
    webp: ownDesignPreviewWebp,
    fallback: ownDesignPreviewFallback,
  },
  {
    name: 'company-gifts/three_sizes_of_tubes.png',
    avif: threeSizesOfTubesPreviewAvif,
    webp: threeSizesOfTubesPreviewWebp,
    fallback: threeSizesOfTubesPreviewFallback,
  },
  {
    name: 'company-gifts/gift_package.png',
    avif: giftPackagePreviewAvif,
    webp: giftPackagePreviewWebp,
    fallback: giftPackagePreviewFallback,
  },
  {
    name: 'job-offers.jpg',
    avif: jobOffersAvif,
    webp: jobOffersWebp,
    fallback: jobOffersFallback,
  },
  ...creditStepsImages,
  ...paymentsImages,
  ...transportImages,
  ...companyGiftsImages,
]

export const defaultImage = {
  avif: defaultImgAvif,
  webp: defaultImgWebp,
  fallback: defaultImgFallback,
}
